import type { EdgeId, RGBColorNumber } from '@ipfabric/utils';
import { highlightEdge } from 'components/Graph/commands/edges/highlightEdge';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface HighlightEdgesCommand {
  color?: RGBColorNumber;
  edges: EdgeId[];
  thickness?: number;
}

export const highlightEdges: GraphCommandFactory<HighlightEdgesCommand> =
  (_cmdContext, dispatch) => (command) => {
    for (const edgeId of command.edges) {
      dispatch(highlightEdge, {
        color: command.color,
        edgeId,
        thickness: command.thickness,
      });
    }
  };
